import { Glyphicon, Table } from 'react-bootstrap'

import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'

require('./experiment.css')

/**
 * React component used to display the list of bioSAXS experiments performed for a given session
 */
export class SaxsExperiment extends React.Component {
  render() {
    return (
      <div
        className="experimentPanel"
        style={{
          backgroundColor:
            this.props.backgroundColorCode && this.props.backgroundColorCode === 1 ? '#fafafa' : '#ffffff',
        }}
        onClick={() => this.props.onExperimentClicked(this.props.experiment)}
      >
        <div
          className={this.props.isSelected ? 'selectedExperiment' : null}
          style={{ borderTop: '1px solid #cecece', paddingLeft: '8px', paddingTop: '4px' }}
        >
          <ExperimentType {...this.props} />
          <Link to={this.props.downloadURL || '#'}>{/*JBC: download URL is never set ?!?*/}
            <Glyphicon glyph="download" />
          </Link>
          <br />
          <span style={{ fontSize: '11px' }}> {this.props.creationDate} </span>
          <br />
          <span style={{ fontSize: '11px' }}> {this.props.name}</span>
          <br />
          <Table id="experimentTable" responsive style={{ paddingLeft: '8px' }}>
            <tbody>
              <ExperimentStatisticBar
                experimentType={this.props.experimentType}
                firstColumnText="Samples"
                numberOf={this.props.measurementDoneCount}
                totalOf={this.props.measurementCount}
              />
              <ExperimentStatisticBar
                experimentType={this.props.experimentType}
                firstColumnText="Averages"
                numberOf={this.props.measurementAveragedCount}
                totalOf={this.props.measurementCount}
              />
              <ExperimentStatisticBar
                experimentType={this.props.experimentType}
                firstColumnText="Subtractions"
                numberOf={this.props.dataCollectionDoneCount}
                totalOf={this.props.dataCollectionCount}
              />
            </tbody>
          </Table>
        </div>
      </div>
    )
  }
}

/** React componenent used to render the experiment type */
const ExperimentType = props => {
  if (props.experimentType === 'CALIBRATION') {
    return (
      <span className="textInColoredSpan" style={{ backgroundColor: '#2E9AFE' }}>
        {props.experimentType}
      </span>
    )
  } else if (props.experimentType === 'STATIC') {
    return (
      <span className="textInColoredSpan" style={{ backgroundColor: '#088A08' }}>
        SAMPLE_CHANGER
      </span>
    )
  } else if (props.experimentType === 'HPLC') {
    return (
      <span className="textInColoredSpan" style={{ backgroundColor: '#AC58FA' }}>
        {props.experimentType}
      </span>
    )
  }
  return <span> NA</span>
}

/** React component used to render a experiment statistic bar */
const ExperimentStatisticBar = props => {
  const barWidth = Math.round((props.numberOf / props.totalOf) * 100).toString() + '%'
  if (
    props.experimentType === 'CALIBRATION' ||
    props.experimentType === 'STATIC' ||
    (props.experimentType === 'HPLC' && props.firstColumnText === 'Subtractions')
  ) {
    return (
      <tr style={{ fontSize: '10px', textAlign: 'center' }}>
        <td> {props.firstColumnText} </td>
        <td>
          <div className="meter-wrap">
            <div className="meter-value" style={{ width: barWidth }} />
            <div className="meter-text">
              {props.numberOf} of {props.totalOf}
            </div>
          </div>
        </td>
      </tr>
    )
  }
  return null
}

SaxsExperiment.propTypes = {
  /** a number 0 or 1 used to display alternative background colors */
  backgroundColorCode: PropTypes.number,
  /** the experiment type */
  experimentType: PropTypes.oneOf(['HPLC', 'CALIBRATION', 'STATIC']),
}
